import { API_AUTH } from "./common";

const TraGopApi = {
  // list: ({
  //   dateFrom,
  //   dateTo,
  //   code,
  //   customerName,
  //   address,
  //   noteTaiSan,
  //   status,
  //   debt,
  //   userName,
  //   pageIndex,
  //   pageSize,
  //   taiSan = 0,
  //   dongtungay,
  //   dongdenngay,
  // }) =>
  //   API_AUTH.get(
  //     `quanlychovay/danh-sach-tra-gop?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),
  list: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    taiSan = 0,
    manhanvien,
    dongtungay,
    dongdenngay,
    taiKhoanIcloudId,
    nguonKhachHangId,
  }) =>
    API_AUTH.get(
      `quanlychovay/danh-sach-tra-gop1?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}
      &userName=${userName}&taiSan=${taiSan}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&manhanvien=${manhanvien}
      &pageIndex=${pageIndex}&pageSize=${pageSize}&taiKhoanIcloudId=${taiKhoanIcloudId}&nguonKhachHangId=${nguonKhachHangId}`,
      {}
    ),
  addAndEdit: ({ ChoVay, Customer, IsChoDuyet = false, IsCopy = false }) =>
    API_AUTH.post("quan-ly-cho-vay/them-sua-tra-gop", {
      ChoVay,
      Customer,
      IsChoDuyet,
      IsCopy,
    }),
  daoHo: ({ ChoVay }) =>
    API_AUTH.post("quan-ly-cho-vay/dao-ho", {
      ...ChoVay,
    }),
  addGhiChu: (params) => API_AUTH.post("PaidGhiChu/SaveGhiChuKyLai", params),
  ChiTietGhiChu: (PaidId) => {
    return API_AUTH.get(`PaidGhiChu/GetDanhSachByKyLai?PaidId=${PaidId}`, {});
  },
  getConfigSys: () => API_AUTH.get(`cau-hinh/config-sys`, {}),
  suaKyLai: (chovayID, valueGop, valueGoc) => {
    return API_AUTH.post(
      `quan-ly-cho-vay/sua-tien-gop?chovayID=${chovayID}&valueGop=${valueGop}&valueGoc=${valueGoc}`,
      {}
    );
  },
  inDanhSachDongLai: (chovayId, isHienLaiGoc) => {
    return API_AUTH.get(
      `quan-ly-cho-vay/in-danh-sach-dong-lai?chovayId=${chovayId}&isHienLaiGoc=${isHienLaiGoc}`,
      {}
    );
  },
  toTalTraGop: (
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    taiSan,
    dongtungay,
    dongdenngay,
    maNhanVien,
    pageIndex,
    pageSize,
    taiKhoanIcloudId,
    nguonKhachHangId
  ) => {
    return API_AUTH.get(
      `quanlychovay/tong-tra-gop?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}
      &userName=${userName}&taiSan=${taiSan}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&maNhanVien=${maNhanVien}&pageIndex=${pageIndex}&pageSize=${pageSize}&taiKhoanIcloudId=${taiKhoanIcloudId}
      &nguonKhachHangId=${nguonKhachHangId}`,
      {}
    );
  },
  getPhiPhatByChoVayId: (chovayId) => {
    return API_AUTH.get(
      `tra-gop/danh-sach-phi-phat-cho-vay?chovayId=${chovayId}`
    );
  },
};

export default TraGopApi;
